module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authors"
  }, [_vm._l((_vm.authors), function(author, index) {
    return [(_vm.authors.length > 1 && index > 0) ? [((_vm.authors.length - index) === 1) ? [_vm._v(" and ")] : [_vm._v(", ")]] : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(author.name_first) + " " + _vm._s(author.name_middle ? author.name_middle + ' ' : '') + _vm._s(author.name_last))])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfcee144"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/IssueAuthorsComponent.vue
// module id = 1472
// module chunks = 1